export default __webpack_public_path__ + "static/media/Apple Macintosh.f4795cb5.svg";